import md5 from "md5";
import { API } from "aws-amplify";

export const isFileTooLarge = value => {
  const MAX_FILE_SIZE_IN_BYTES = 2097152;
  const filesizeInBytes = value.size;
  if (value && filesizeInBytes > MAX_FILE_SIZE_IN_BYTES) return true;
  else return false;
};

export const getSocialImageUrl = async (email, identities) => {
  const identity = JSON.parse(identities);
  const providerType = identity[0].providerType;
  const userId = identity[0].userId;
  const response = API.get("getSocialAvatar", `/${email}`, {
    queryStringParameters: {
      email,
      userId,
      providerType
    }
  });
  return response;
};

export const getEWPAvatar = avatar => {
  const avatar_cloudfront_url = process.env.REACT_APP_MC_AVATAR_CF_URL;
  const imgurl = `${avatar_cloudfront_url}/${avatar}`;
  return imgurl;
};
export const getGravatar = email => {
  const avatar_cloudfront_url = process.env.REACT_APP_MC_AVATAR_CF_URL;
  const gravtarUrlPrefix = "https://www.gravatar.com/avatar";
  const favatarUrl = `${avatar_cloudfront_url}/favatar.png`;
  const hash = email ? md5(email) : "";
  const imgurl = `${gravtarUrlPrefix}/${hash}?d=${favatarUrl}`;
  return imgurl;
};

/**
 * Preload image urls for sucessful logged in user
 * state has all these image urls available on page load to avoid delays
 * 'imageurl' is the state variable that holds the url displayed in UI
 * it can hold a EWP avatar or social image or gravatar
 * Always sets imageurl to gravatar by default, but if a social profile image or EWP
 * avatar exists for that profile, gravatar value will be overidden
 * we are not saving gravatar or social image in DB and S3.
 * Only user uploaded avatar image is stored in DB and S3
 * social and gravatar image urls are populated in the state variables on the fly after a user logs in
 *
 * @param cognitoUser
 */
export const preloadImageUrls = async cognitoUser => {
  if (cognitoUser && cognitoUser.attributes) {
    const email = cognitoUser.attributes.email;
    const attributes = cognitoUser.attributes;
    const identities = attributes.identities;
    //sets Gravatar
    cognitoUser.gravatarurl = getGravatar(attributes.email);
    cognitoUser.imageurl = cognitoUser.gravatarurl;

    //checks for social identities and sets social profile image if exists.
    if (identities) {
      const response = await getSocialImageUrl(email, identities);
      cognitoUser.socialImageUrl = response.result;
    }
  }
  //sets avatar url
  const avatar = cognitoUser.avatar;
  if (avatar) {
    cognitoUser.imageurl = getEWPAvatar(avatar);
  } else if (!avatar && cognitoUser.socialImageUrl) {
    cognitoUser.imageurl = cognitoUser.socialImageUrl;
  }
  return;
};
